var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "layout-padding" }, [
      _c("div", { staticClass: "row gutter-sm q-mb-md" }, [
        _c(
          "div",
          { staticClass: "col" },
          [
            _c(
              "q-card",
              { staticClass: "dash-number-box bg-white" },
              [
                _c("q-card-title", { staticClass: "text-center" }, [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("beta_headline")) +
                      "\n          "
                  )
                ]),
                _c("q-card-separator"),
                _c("q-card-main", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("beta_content")) +
                      "\n          "
                  )
                ]),
                _c(
                  "q-card-footer",
                  { staticClass: "row justify-end" },
                  [
                    _c(
                      "q-btn",
                      {
                        attrs: { flat: "", color: "primary" },
                        on: { click: _vm.handleNewVersion }
                      },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("beta_button")) +
                            "\n            "
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm.statisticsLoaded
        ? _c("div", { staticClass: "row gutter-sm" }, [
            _c(
              "div",
              { staticClass: "col-md-4 col-12" },
              [
                _c("revenue-card", {
                  attrs: {
                    revenue: _vm.revenue.value,
                    currency: _vm.currency,
                    average: _vm.revenueAverage
                  },
                  on: {
                    averageYearChanged: _vm.handleRevenueAverageYearChanged
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-4 col-12" },
              [
                _c("overdue-invoices-card", {
                  style: { height: "calc(50% - 0.5rem)", marginBottom: "1rem" },
                  attrs: {
                    amount: _vm.overdueInvoiceAmount.value,
                    number: _vm.overdueInvoiceNumber.value,
                    currency: _vm.currency
                  }
                }),
                _c("unpaid-invoices-card", {
                  style: { height: "calc(50% - 0.5rem)" },
                  attrs: {
                    amount: _vm.unpaidInvoiceAmount.value,
                    number: _vm.unpaidInvoiceNumber.value,
                    currency: _vm.currency
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-4 col-12" },
              [
                _c("expenses-card", {
                  attrs: {
                    expenses: _vm.expensesStatistic.value,
                    currency: _vm.currency,
                    average: _vm.expensesAverage
                  },
                  on: {
                    averageYearChanged: _vm.handleExpensesAverageYearChanged
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.statisticsLoaded
        ? _c("div", { staticClass: "row gutter-sm q-mt-none" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c(
                  "q-card",
                  { staticClass: "dash-number-box bg-white" },
                  [
                    _c("q-card-title", { staticClass: "text-center" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("last_invoices")) +
                          "\n          "
                      )
                    ]),
                    _c("q-card-separator"),
                    _c(
                      "q-card-main",
                      [
                        _vm.lastInvoices.length
                          ? _c("invoice-table", {
                              staticClass: "no-shadow",
                              attrs: { invoices: _vm.lastInvoices }
                            })
                          : [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "row justify-center items-center col-grow q-pt-lg"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "text-center" },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("assets/emptystates/invoices_empty.svg"),
                                          width: "30%"
                                        }
                                      }),
                                      _c(
                                        "h6",
                                        { staticClass: "q-my-md text-faded" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("invoices_empty"))
                                          )
                                        ]
                                      ),
                                      _c(
                                        "q-btn",
                                        {
                                          staticClass: "q-mt-lg",
                                          attrs: {
                                            color: "primary",
                                            outline: ""
                                          },
                                          on: { click: _vm.handleCreateInvoice }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(_vm.$t("create_invoice")) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.statisticsLoaded
        ? _c("div", { staticClass: "row gutter-sm q-mt-none" }, [
            _c(
              "div",
              { staticClass: "col" },
              [
                _c(
                  "q-card",
                  { staticClass: "dash-number-box bg-white" },
                  [
                    _c("q-card-title", { staticClass: "text-center" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.$t("last_activities")) +
                          "\n          "
                      )
                    ]),
                    _c("q-card-separator"),
                    _c(
                      "q-card-main",
                      [
                        _c("activities-list", {
                          attrs: { activities: _vm.activities }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }